import { useLocales } from '@/Locales';
import { httpPatientLectureNoteGenerate } from '@/services/lecture';
import { Modal } from '@sinohealth/butterfly-ui-components';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './index.less';

interface GeneratePPTNotesProps {
  reStart?: boolean;
  onOk?: (id: string, patientId?: string) => void;
}

/**
 * @description: PPT内容生成说明
 * @author: KaifengLi
 * @version: v2.29.0
 * @Date: 2025-01-02 15:17:13
 */
const GeneratePPTNotes = forwardRef((props: GeneratePPTNotesProps, ref: any) => {
  const { t } = useLocales();
  const { reStart } = props;
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [patientId, setPatientId] = useState<string>('');

  useImperativeHandle(ref, () => ({
    open: (id: string) => {
      setOpen(true);
      setPatientId(id);
    },
  }));

  const httpPatientPPTGenerateV3Req = async () => {
    try {
      setLoading(true);
      const res: any = await httpPatientLectureNoteGenerate({
        patientId,
      });
      // console.log(res);
      // const url = `${window.location.pathname}#/combinedWard/pptEditor`;
      // window.open(
      //   `${url}?id=${res.fileId}&patientId=${patientId}&fileName=${res.fileName}&fileServerAddress=${res.fileServerAddress}&documentServerAddress=${res.documentServerAddress}`,
      //   '_blank',
      //   'noreferrer',
      // );

      setOpen(false);
      props?.onOk?.(res, patientId);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handleOk = async () => {
    httpPatientPPTGenerateV3Req();
  };

  return (
    <Modal
      title={reStart ? t('讲稿重新生成提示') : t('讲稿生成提示')}
      width={400}
      className={styles['generate-notes']}
      open={open}
      onOk={handleOk}
      confirmLoading={loading}
      okText={!reStart ? t('确定生成') : t('重新生成')}
      onCancel={() => setOpen(false)}
    >
      {!reStart && (
        <div>
          {t(
            '系统将根据已上传的入院记录、出院记录、影像报告等病例资料，自动提取内容生成讲稿PPT。请在最终生成前，务必确认所有资料的准确性与完整性。',
          )}
        </div>
      )}
      {reStart && (
        <>
          <div className={styles['generate-notes-cover']} style={{ marginBottom: 6 }}>
            确认重新生成？
          </div>
          <div>
            系统将根据最新资料生成新的讲稿，并
            <span className={styles['generate-notes-cover']}>覆盖</span>
            现有版本。{' '}
            <span className={styles['generate-notes-warning']}>请注意：此操作无法撤销。</span>
          </div>
        </>
      )}
    </Modal>
  );
});

export default GeneratePPTNotes;
